<template>
    <div
        class="bg-gray-100 py-5 md:py-12"
    >
        <div class="container m-auto">
            <h2 class="text-2xl md:text-5xl">
                {{ props.title }}
            </h2>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        title: string
    }>()
</script>
